/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Display status of a survey on the Review & Confirm summary.
 */
export enum SurveySeasonSummaryStatus {
    READY_TO_SET_UP = 'readyToSetUp',
    AWAITING_DATA_UPLOAD = 'awaitingDataUpload',
    AVAILABLE = 'available',
}
